<template>
  <div>
    <a-table :scroll="{ x: 1200 }" :pagination="false" :columns="columns" size="middle" :data-source="dataSource" :loading="loading" row-key="id">
      <span slot="customKey" slot-scope="text, record">
        <div v-if="record.is_fault" class="corner" @click="onViewFault(record)" />
        <span>PB-{{ record.id }}</span>
      </span>
      <span slot="urgency" slot-scope="text, record">
        <a-tag v-if="problemUrgencys[record.urgency]" :color="problemUrgencys[record.urgency].color">{{ problemUrgencys[record.urgency].label }}</a-tag>
        <span v-else>--</span>
      </span>
      <span slot="problemTitle" slot-scope="text, record">
        <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
      </span>
      <span slot="tag" slot-scope="text, record">
        <a-popover v-if="record.tags" title="问题标签" placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
        </a-popover>
        <span v-else>--</span>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag :color="problemStatus[record.status].color"> {{ problemStatus[record.status].label }}</a-tag>
      </span>
    </a-table>
  </div>
</template>

<script>
import { problemUrgencys, problemStatus, problemChannels } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 70,
    scopedSlots: { customRender: 'customKey' }
  },
  {
    title: '标题',
    width: 400,
    ellipsis: true,
    scopedSlots: { customRender: 'problemTitle' }
  },
  {
    title: '状态',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '紧急程度',
    width: 80,
    scopedSlots: { customRender: 'urgency' }
  },
  {
    title: '处理人',
    width: 100,
    customRender: record => {
      return record.handler === null ? '--' : record.handler.nickname;
    }
  },
  {
    title: '反馈人',
    width: 100,
    customRender: record => {
      return record.reporter === null ? '--' : record.reporter.nickname;
    }
  },
  {
    width: 164,
    align: 'center',
    title: '上报时间',
    key: 'reported_time',
    dataIndex: 'reported_time',
    customRender: text => {
      return text || '--';
    }
  },
  {
    width: 164,
    align: 'center',
    title: '开始时间',
    key: 'started_time',
    dataIndex: 'started_time',
    customRender: text => {
      return text || '--';
    }
  },
  {
    width: 164,
    align: 'center',
    title: '解决时间',
    key: 'resolved_time',
    dataIndex: 'resolved_time',
    customRender: text => {
      return text || '--';
    }
  }
];

export default {
  components: {},
  props: {
    dataSource: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      expand: true,
      sourceId: null,
      problemId: null,
      problemStatus,
      problemChannels,
      problemUrgencys,
      columns
    };
  },

  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    link() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:event:problem:detail',
          query: { problemId: record.sourceId }
        });
        return route.href;
      };
    }
  },
  methods: {
    // 查看详情
    onDetail(record) {
      this.$router.push({
        name: 'page:event:problem:detail',
        query: {
          problemId: record.id
        }
      });
    },

    // 查看故障详情
    onViewFault(record) {
      this.$router.push({
        name: 'page:event:fault:detail',
        query: {
          faultId: record.id
        }
      });
    },

    onToFault(record) {
      this.sourceId = record.id;
      this.faultVisible = true;
    },

    // 关闭弹窗
    close(type) {
      this.modalVisible = false;
      this.faultVisible = false;
      if (type === 'submit') {
        this.getProblemList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
/deep/.is-fault.ant-tag {
  margin-right: 0;
}

.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: 'RCA';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  /* 颜色变暗：filter滤镜、半透明遮罩 */
  /* 使用filter滤镜 使颜色变暗 */
  /*filter: brightness(.6);*/
  /* 给颜色上添加一个半透明遮罩实现颜色变暗 */
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit; /* 继承 */
}
</style>
